var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGalleryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0002 36.6666H25.0002C33.3335 36.6666 36.6668 33.3333 36.6668 25V15C36.6668 6.66665 33.3335 3.33331 25.0002 3.33331H15.0002C6.66683 3.33331 3.3335 6.66665 3.3335 15V25C3.3335 33.3333 6.66683 36.6666 15.0002 36.6666Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 16.6667C16.8408 16.6667 18.3332 15.1743 18.3332 13.3333C18.3332 11.4924 16.8408 10 14.9998 10C13.1589 10 11.6665 11.4924 11.6665 13.3333C11.6665 15.1743 13.1589 16.6667 14.9998 16.6667Z",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44971 31.5834L12.6664 26.0667C13.983 25.1834 15.883 25.2834 17.0664 26.3001L17.6164 26.7834C18.9164 27.9001 21.0164 27.9001 22.3164 26.7834L29.2497 20.8334C30.5497 19.7167 32.6497 19.7167 33.9497 20.8334L36.6664 23.1667",
    stroke: "#1C1C1C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGalleryIcon);
export default __webpack_public_path__ + "static/media/galleryIcon.47bd042d05a871f3570d37ac68695b1f.svg";
export { ForwardRef as ReactComponent };